import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Campaign from './Campaigns';

const Index = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Main Content */}
      <div
        className={`flex-1 transition-all duration-300 ease-in-out ${
          isSidebarOpen ? 'ml-0 md:ml-64' : 'ml-0'
        }`}
        style={{
          transform: isSidebarOpen ? 'translateX(16rem)' : 'translateX(0)',
        }}
      >
        <Campaign />
      </div>
    </div>
  );
};

export default Index;